import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { requestTransactionHistory } from 'store/api/cuverse-api/transaction/transaction.service';
import { ITransactionHistoryRequestParams } from 'store/api/cuverse-api/transaction/types/transaction-history-request.interface';
import {
  TransactionHistoryResponseSchema,
  TTransactionHistoryData,
} from 'store/api/cuverse-api/transaction/types/transaction-history-response.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const requestTransactionHistoryData = createAsyncThunk(
  'transaction/fetch',
  async ({
    count,
    dateStart,
  }: ITransactionHistoryRequestParams): Promise<TTransactionHistoryData> => {
    return await requestWithZodSchema(
      () => requestTransactionHistory({ count, dateStart }),
      TransactionHistoryResponseSchema,
    ).catch((error) => {
      notifyError(i18n.t('notifyMessages.transactionHistory.dataLoadError'));
      throw error;
    });
  },
);
